import React, { Fragment, Component } from "react";
import SubHeader from "./../../Common/Layout/SubHeader";
import ClientsTable from "./ClientsTable";
import { connect } from "react-redux";
import ClientsHeader from "./ClientsHeader";
import ClientGridAction from "./ClientGridAction"
import ClientPageActions from "./ClientPageActions"
import BulkEditClients from "./BulkEdit/BulkEdit";

import { Dimmer, Modal, Loader, Grid, Icon, Button } from "semantic-ui-react";
import moment from "moment";
import { bindActionCreators } from "redux";
import { createNotification, NOTIFICATION_TYPE_SUCCESS } from 'react-redux-notify';

class Clients extends Component {
    constructor(props) {
        super(props)

        this.state = {
            subHeaderItems: [],
            helpMenuItems: [
            ]
        }
    }

    componentDidMount() {

    }
    toggleBulkEditForm() {
        this.setState({
            shouldModalOpen: !this.state.shouldModalOpen
        });
    }
    render() {     
        let len = this.props.selectedClients.selectedClientsIds;

        return (
            <Fragment>
            <div >
                    <ClientPageActions />
                    {len.length ? (
                        <ClientGridAction
                            toggleBulkEditForm={this.toggleBulkEditForm.bind(this)}
                        />
                    ) : (
                        ""
                    )}

                    <ClientsTable />
                </div>
                <BulkEditClients
                    shouldModalOpen={this.state.shouldModalOpen}
                    toggleBulkEditForm={this.toggleBulkEditForm.bind(this)}
                />
                </Fragment>
        );
    }
}
const mapStateToProps = state => {    
    return {
        selectedClients: state.allClients.selectedClients,
    }
};

export default connect(
    mapStateToProps
)(Clients);


